module.exports = __webpack_public_path__ + "static/media/omega-sketch-rough-color.02cb4707.png";